import actions from './actions';

// A function, not a constant: after a logout the state must be rebuilt from the (now cleared) localStorage, not from
// the values read when the module was first loaded.
const buildInitState = () => ({
  idToken: localStorage.getItem('id_token'),
  role: localStorage.getItem('id_role'),
  userId: localStorage.getItem('id_user'),
  agencyIsActive: localStorage.getItem('agency_is_active') === 'false' ?  false : true,
  isLoadingLogin: false,
  isLoadingResetPassword: false,
  error: null,
  resetPasswordMessage: null,
  resetPasswordConfirmMessage: null,
  isLoadingResetPasswordConfirm: false,
  accessNotFound: false,
  googleProfile: null,
});

const initState = buildInitState();

export default function authReducer(state = initState, { type, payload }) {
  switch (type) {
    case actions.LOGIN_REQUEST:
      return {
        isLoadingLogin: true
      };
    case actions.GOOGLE_LOGIN_REQUEST:
      return {
        isLoadingLogin: true
      };
    case actions.ACCESS_NOT_FOUND:
      return {
        ...initState,
        isLoadingLogin: false,
        idToken: null,
        accessNotFound: true,
        googleProfile: payload.profile || null
      };
    case actions.CLOSE_ACCESS_NOT_FOUND:
      return {
        ...state,
        accessNotFound: false,
        googleProfile: null
      };
    case actions.LOGIN_SUCCESS:
      return {
        isLoadingLogin: false,
        idToken: payload.firebaseToken,
        role: payload.role,
        userId: payload.userId,
        agencyIsActive: payload.agencyIsActive
      };
    case actions.LOGIN_ERROR:
      return {
        ...initState,
        isLoadingLogin: false,
        idToken: null,
        error: payload.error.message
      };
    case actions.RESET_PASSWORD_REQUEST:
      return {
        ...initState,
        isLoadingResetPassword: true
      };
    case actions.RESET_PASSWORD_SUCCESS:
      return {
        ...initState,
        isLoadingResetPassword: false,
        resetPasswordMessage: payload.message
      };
    case actions.RESET_PASSWORD_ERROR:
      return {
        ...initState,
        isLoadingResetPassword: false,
        resetPasswordMessage: payload.error.message
      };
    case actions.RESET_PASSWORD_CONFIRM:
      return {
        ...initState,
        isLoadingResetPassword: true
      };
    case actions.RESET_PASSWORD_CONFIRM_SUCCESS:
      return {
        ...initState,
        isLoadingResetPasswordConfirm: false,
        resetPasswordConfirmMessage: payload.message
      };
    case actions.RESET_PASSWORD_CONFIRM_ERROR:
      return {
        ...initState,
        isLoadingResetPasswordConfirm: false,
        resetPasswordConfirmMessage: payload.error.message
      };
    case actions.LOGOUT:
      return buildInitState();
    case actions.LOGOUT_SUCCESS:
      return {
        ...buildInitState(),
        idToken: null,
        userId: null,
        agencyIsActive: true,
        error: null,
        role: null
      };
    default:
      return state;
  }
}
